import { FeesRoutes as FeesRoutesEnum } from '../routes';
import Fees from '../hoc/fees/fees';
import FeesList from '../hoc/fees/list';  
import FeeForm from '../hoc/fees/form';

const FeesRoutes = {
  path: FeesRoutesEnum.FEES ,
  element: <Fees />,
  children: [
    {
      path: FeesRoutesEnum.FEES_LIST,
      element: <FeesList />,
      children: [
        {
          path: FeesRoutesEnum.FEES_CREATE,
          element: <FeeForm />,
        },
        {
          path: FeesRoutesEnum.FEES_ITEM,
          element: <FeeForm />,
        }
      ],
    },
  ],
};

export default FeesRoutes;
